import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import { BrowserRouter } from 'react-router-dom'; // ✅ Import this

// Redirect for GitHub Pages on refresh (404 fix)
if (
  window.location.pathname !== '/' &&
  !window.location.pathname.includes('.')
) {
  sessionStorage.redirect = window.location.href;
  window.location.href = '/'; // ✅ Replace this with your actual repo name
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

